import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import ScheduleYourFreeDemo from "./sections/ScheduleYourFreeDemo";
import GetInTouch from "./sections/GetInTouch";
import LetsTalkLearning from "./sections/LetsTalkLearning";
import VistaportFooter from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <ScheduleYourFreeDemo />
      <GetInTouch />
      <LetsTalkLearning />
      <VistaportFooter />
    </div>;
}